import throttle from 'lib/throttle'
import { useState, useEffect } from 'react'

export default function useHasGotToAnchor(element?: Element, rootMargin: number = 0): boolean {
  const [hasGotToAnchor, setHasGotToAnchor] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (element) {
        setHasGotToAnchor(element.getBoundingClientRect().top + rootMargin <= 0)
      }
    }

    window.addEventListener('scroll', throttle(handleScroll, 200, { leading: true, trailing: true }))

    return () => {
      window.removeEventListener('scroll', () => throttle(handleScroll, 200))
    }
  }, [element, rootMargin])

  return hasGotToAnchor
}
